import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";

import "react-data-table-component-extensions/dist/index.css";
import Header from "../layouts/Header";
import Sidebar from "../layouts/Sidebar";
import axios from "../api/axios";
import FindModuleById from '.././FindModuleById';
import {  Apitoken, Authtoken } from "../Global";
import {MaterialReactTable} from 'material-react-table';
import Swal from 'sweetalert2';
import {

  MenuItem,

} from '@mui/material';


const ProcurementList = () => {
  const [menu, setMenu] = useState(false);
  const [data, setData] = useState([]);
  const [permission, setPermission] = useState({});

  useEffect(() => {
        setPermission(FindModuleById(439)); 
      console.log(permission);

    axios
      .post(
        "/procurementsupplier/listing",
        {},
        {
          headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },
        }
      )
      .then((response) => {
        setData(response.data.data.suppliers);
        console.log(response);
      })
      .catch((error) => {
        console.log(error);
      });
  }, []);

  const deleteItem = (item) => {
    Swal.fire({
      title: 'Do you really want to delete this record?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'DELETE'
    }).then((result) => {
      if (result.isConfirmed) {
        axios.get(`/procurementsupplier/delete/${item}`, {
              headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },
            })
            .then((response) => {
              console.log(response);
              if (response.data.code === 200) {
                Swal.fire(
                  'Deleted!',
                  'Your Record has been deleted.',
                  'success'
                );
                setTimeout(() => {
                  window.location.href = "/procurementsuppliers";
                }, 500);
              }
            })
            .catch((error) => {
              console.log(error);
            });
      }
    });
  }
  const toggleMobileMenu = () => {
    setMenu(!menu);
  };



  const editItem = (item)=>{
    window.location.href = "/procurementsuppliers-edit/"+item;
  }
  const columns =
  [
    {
      accessorKey: 'name', //normal accessorKey
      header: 'Name',
    },
    {
      header: 'Supplier Type',
      accessorFn: (row) => `${(row.supply_type)?row.supply_type.title:""} `,
    },
    {
      accessorKey: 'contact_person', //normal accessorKey
      header: 'Contact Person',
    }, 
     {
      accessorKey: 'phone_number', //normal accessorKey
      header: 'Phone Number',
    }, 
    {
      accessorKey: 'bank_number', //normal accessorKey
      header: 'Bank Number',
    },
    {
      accessorKey: 'bank_name', //normal accessorKey
      header: 'Bank Name',
    },
    {
      accessorKey: 'if', //normal accessorKey
      header: 'IF',
    },{
      accessorKey: 'ice', //normal accessorKey
      header: 'ICE',
    },
    {
      accessorKey: 'address', //normal accessorKey
      header: 'Address',
    },
    {
      header: 'Created By',
      accessorFn: (row) => `${(row.createdby)?row.createdby.first_name+ ' '+ row.createdby.last_name:""} `,
    },
    {
      header: 'Updated By',
      accessorFn: (row) => `${(row.updatedby)?row.updatedby.first_name+ ' '+ row.updatedby.last_name:""} `,
    },
   ];


  return (
    <div className={`main-wrapper ${menu ? "slide-nav" : ""}`}>
      <Header onMenuClick={() => toggleMobileMenu()} />
      <Sidebar />

      <div className="page-wrapper">
        <div className="content container-fluid">
          <div className="page-header">
            <div className="row align-items-center">
              <div className="col">
                <h3 className="page-title">Procurement Suppliers</h3>
                <ul className="breadcrumb">
                  <li className="breadcrumb-item">
                    <Link to="/profile">Profile</Link>
                  </li>
                  <li className="breadcrumb-item active">Procurement Suppliers</li>
                </ul>
              </div>
              <div className="col-auto">
                 {permission && permission.add == 1 && (
                    <Link to="/procurementsuppliers-add" className="btn btn-primary me-1">
                    <i className="fas fa-plus"></i>
                  </Link>
                  )}
                
              </div>
            </div>
          </div>

          <div className="row">
            <div className="col-sm-12">
              <div className="card card-table">
                <div className="card-body">
                  <div className="table-responsive">
                      {permission && permission.list == 1 && (
                        <MaterialReactTable columns={columns} data={data} 
                          enableColumnOrdering
                          enablePinning
                          enableRowActions
                          //renderColumnActionsMenuItems 
                          renderRowActionMenuItems={({ row }) => [
                            permission?.update == 1 && (
                              <MenuItem key="edit" onClick={() => editItem(row.original.id)}>
                                Edit
                              </MenuItem>
                            ),
                            permission?.delete == 1 && (
                              <MenuItem key="delete" onClick={() => deleteItem(row.original.id)}>
                                Delete
                              </MenuItem>
                            ),
                          ]}
                        />
                      )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default ProcurementList;
